<template>
	<section class="page">
		<el-tabs v-model="activeName">
			<el-tab-pane label="预留仓库管理" name="list">
				<div class="content-box">
					<div class="operator">
						<div class="operator-col">
							<el-button size="mini" type="primary" @click="handleCreate()" v-loading="loadings.create">新建</el-button>
						</div>
					</div>
					<curd-table
						ref="listTable"
						:data-model="editorDataModel"
						:fields="tableFields"
						@doedit="handleEdit($event)"
					></curd-table>
				</div>
			</el-tab-pane>
		</el-tabs>
		<editor
			:show.sync="editorVisible"
			:data-model-name="editorDataModel"
			:record-id="editorId"
			:fields="editorFields"
			@change="onEdited"
		></editor>
	</section>
</template>

<script>
import CurdPage from "@/mixins/CurdPage.js";
import { mapState, mapGetters, mapMutations } from "vuex";

export default {
	mixins: [CurdPage],

	data() {
		return {
			editorDataModel: "Reserve_storehouse",
			tableFields: [
				{
					name: "name",
					sortable: "custom"
				},
			],
			editorFields: [
				{
					name: "name",
					rules: ["required"]
				},
			]
		};
	},
	methods: {
		...mapMutations(["checkPrivilege", "getStorehouses"]),
		onEdited() {
			this.getStorehouses(true);
			this.refreshTable("listTable");
		}
	}
};
</script>
<style lang="scss" scoped>
</style>
